import http from '../http/http';
import URL from '../constant/URL';

const { COMMON } = URL.API.LEARNING;

// 학습결과 
export const learningResultAPI = async (data) => {
  let result = null;
  
  await http.request({
    url: `${COMMON.RESULT}`,
    method: http.METHOD.POST,
    data,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}

// 오답확인
export const checkWransrAnswerAPI = async (data) => {
  let result = null;
  const token = data?.token;
  delete data.token;
  await window.fetch(
    URL.API.LEARNING.COMMON.WRANSR,
    {
      body: JSON.stringify(data),
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      
    }
  )
  .then((resp) => {
    const jsonData = resp.json();
    return jsonData;
  })
  .then((data) => {
    result = data.data;
  })
  .catch((error) => {
    console.log({ error });
  });
  
  return result;
}